module.exports = __webpack_public_path__ + "img/1_fineStaff_gll.6032f416.png";